import { render, staticRenderFns } from "./automationInsertPlaceholderPopover.vue?vue&type=template&id=be77ba3a&scoped=true&"
import script from "./automationInsertPlaceholderPopover.vue?vue&type=script&lang=js&"
export * from "./automationInsertPlaceholderPopover.vue?vue&type=script&lang=js&"
import style0 from "./automationInsertPlaceholderPopover.vue?vue&type=style&index=0&id=be77ba3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be77ba3a",
  null
  
)

export default component.exports